import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface CoreFeaturesGuardProps {
  children: React.ReactElement;
}

const CoreFeaturesGuard: React.FC<CoreFeaturesGuardProps> = ({ children }) => {
  const { isSuperAdmin, isConnectClient, hasSafetyModules, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isSuperAdmin && !hasSafetyModules && !isConnectClient) {
    return <Navigate to="/subscription-required" replace />;
  }

  return children;
};

export default CoreFeaturesGuard;
